module.exports = __webpack_public_path__ + "media/images/FFE-1220-849ebfbaf028ab7c55bd724b660694f6.png";